// Visitor unified code resolver — `GET /api/by-code/{code}` (F-B Q-OQ-B).
//
// One round trip replaces the legacy "probe zones, fall back to exhibits
// on 404" pattern in CodeEntry. Backend returns {kind, id, code} or
// 404. Visitor-tier filtering — only resolves codes whose target is
// PUBLISHED.

import { getApiClient } from "./client";

export type ByCodeKind = "exhibition" | "zone" | "exhibit";

export interface ByCodeResolution {
  kind: ByCodeKind;
  id: string;
  code: string;
}

export async function resolveByCode(code: string): Promise<ByCodeResolution> {
  const { data } = await getApiClient().get<ByCodeResolution>(
    `/by-code/${code}`,
  );
  return data;
}
